import { render, staticRenderFns } from "./PEFamilies.vue?vue&type=template&id=11668590&"
import script from "./PEFamilies.vue?vue&type=script&lang=js&"
export * from "./PEFamilies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports